import * as React from 'react';

export const nirFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_407)'>
            <path
                d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_407'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_407)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M-0.33406 8.00136H12.0031V0H16.0003V8.00136H28.2712V11.9986H16.0003V20H12.0031V11.9986H-0.33406V8.00136Z'
                    fill='#ED1C2E'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.0017 15.2358L15.5185 12.6332H18.5215L17.0319 9.9966L18.5215 7.36681H15.5185L14.0017 4.76077L12.4815 7.36681H9.47845L10.9681 9.9966L9.47845 12.6332H12.4815L14.0017 15.2358Z'
                    fill='#F1F5F9'
                />
                <path
                    d='M14.0017 15.2358L15.5185 12.6332H18.5215L17.0319 9.9966L18.5215 7.36681H15.5185L14.0017 4.76077L12.4815 7.36681H9.47845L10.9681 9.9966L9.47845 12.6332H12.4815L14.0017 15.2358Z'
                    stroke='#4E4956'
                    strokeWidth='0.2'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.8025 11.2487C14.9179 11.1333 15.1045 11.0044 15.2063 10.7262C15.3047 10.4649 15.5117 10.1561 15.7221 9.95249C15.9325 9.75228 16.2141 9.52493 16.0105 9.3383C15.773 9.12453 15.3624 9.60976 15.2504 9.72174C15.1622 9.80997 15.0366 9.82354 14.9077 9.89141C14.979 9.25347 14.8398 8.77502 14.8229 7.84187C14.8161 7.44485 14.7143 7.18357 14.5344 7.18357C14.3817 7.18357 14.3173 7.29555 14.2935 7.44485C14.2935 7.23108 14.2867 6.87817 14.0356 6.87817C13.7302 6.87817 13.7133 7.43128 13.7472 7.74685C13.7336 7.55344 13.737 7.16321 13.4723 7.16321C13.1941 7.16321 13.1703 7.60773 13.2077 8.00135C13.2077 8.04546 13.2145 8.14387 13.2178 8.26942C13.2178 8.05225 13.1771 7.71631 12.9667 7.71631C12.7733 7.71631 12.753 8.00474 12.7632 8.25585C12.7733 8.50695 12.7937 9.10417 12.7632 9.27383C12.7021 9.60976 12.7326 10.4717 12.753 10.7262C12.7767 11.0587 13.0652 11.1809 13.0516 11.4082C13.0414 11.6356 13.0516 12.0394 13.0516 12.2192C13.0516 12.399 13.2077 12.4092 13.5199 12.338C14.0356 12.226 14.3173 12.4533 14.7414 12.2871C14.6871 11.7883 14.8093 11.432 14.7991 11.2521L14.8025 11.2487Z'
                    fill='#ED1C2E'
                />
                <path
                    d='M14.5344 10.3699C14.6396 10.0679 14.7788 9.94909 14.9077 9.88462M14.7007 11.415C14.7007 11.3505 14.7482 11.303 14.7991 11.2487M13.2212 8.26942C13.2212 8.53749 13.2314 8.91075 13.2314 9.03291M14.2935 7.44146C14.2698 7.58058 14.2867 7.75703 14.3037 7.90634C14.3173 8.00135 14.3342 8.1778 14.3173 8.39158C14.3173 8.46962 14.3716 8.75126 14.3241 8.89378M13.7472 7.74346C13.7845 8.05564 13.7574 8.63589 13.7574 8.9345M14.8025 11.2487C14.9179 11.1333 15.1045 11.0044 15.2063 10.7262C15.3047 10.4649 15.5117 10.1561 15.7221 9.95249C15.9325 9.75228 16.2141 9.52493 16.0105 9.3383C15.773 9.12453 15.3624 9.60976 15.2504 9.72174C15.1622 9.80997 15.0366 9.82354 14.9077 9.89141C14.979 9.25347 14.8398 8.77502 14.8229 7.84187C14.8229 7.44485 14.7143 7.18357 14.5344 7.18357C14.3817 7.18357 14.3173 7.29555 14.2935 7.44485C14.2935 7.23108 14.2867 6.87817 14.0356 6.87817C13.7302 6.87817 13.7133 7.43128 13.7472 7.74685C13.7472 7.55344 13.737 7.16321 13.4723 7.16321C13.1941 7.16321 13.1703 7.60773 13.2077 8.00135C13.2077 8.00135 13.2178 8.14387 13.2178 8.26942C13.2178 8.05225 13.1771 7.71631 12.9667 7.71631C12.7733 7.71631 12.753 8.00474 12.7632 8.25585C12.7632 8.50695 12.7937 9.10417 12.7632 9.27383C12.7021 9.60976 12.7326 10.4717 12.753 10.7262C12.7767 11.0587 13.0516 11.1809 13.0516 11.4082V12.2192C13.0516 12.399 13.2077 12.4092 13.5199 12.338C14.0356 12.226 14.3173 12.4533 14.7414 12.2871C14.6871 11.7883 14.7991 11.432 14.7991 11.2521L14.8025 11.2487Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.0017 3.35595C14.3037 2.97251 15.1181 3.01663 15.3658 3.25416C15.6135 3.49508 16.3498 3.17611 16.6417 3.76315L16.1768 4.87954H11.8164L11.3515 3.76315C11.6468 3.17611 12.3797 3.49169 12.6274 3.25416C12.8751 3.01663 13.6895 2.97251 13.9949 3.35595H14.0017Z'
                    fill='#ED1C2E'
                />
                <path
                    d='M14.0017 3.35595C14.3037 2.97251 15.1181 3.01663 15.3658 3.25416C15.6135 3.49508 16.3498 3.17611 16.6417 3.76315L16.1768 4.87954H11.8164L11.3515 3.76315C11.6468 3.17611 12.3797 3.49169 12.6274 3.25416C12.8751 3.01663 13.6895 2.97251 13.9949 3.35595H14.0017Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.0017 2.9284C14.1442 2.9284 14.2596 2.99626 14.2596 2.68408C14.2596 2.3719 14.1442 2.44316 14.0017 2.44316C13.8592 2.44316 13.7438 2.37529 13.7438 2.68408C13.7438 2.99287 13.8592 2.9284 14.0017 2.9284Z'
                    fill='#FFF200'
                />
                <path
                    d='M14.0017 2.9284C14.1442 2.9284 14.2596 2.99626 14.2596 2.68408C14.2596 2.3719 14.1442 2.44316 14.0017 2.44316C13.8592 2.44316 13.7438 2.37529 13.7438 2.68408C13.7438 2.99287 13.8592 2.9284 14.0017 2.9284Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.1612 1.57109C14.2867 1.58127 14.4157 1.63896 14.5039 1.69665V1.11979C14.4157 1.18087 14.2867 1.23177 14.1612 1.24534C14.1748 1.11979 14.229 0.990844 14.2867 0.902618H13.7099C13.771 0.990844 13.8219 1.11979 13.8354 1.24534C13.7099 1.23177 13.5809 1.18087 13.4927 1.11979V1.69665C13.5809 1.63896 13.7099 1.58467 13.8354 1.57109C13.8219 1.69325 13.7676 2.01561 13.7099 2.10384H14.2867C14.229 2.01561 14.1748 1.69325 14.1612 1.57109Z'
                    fill='#FFF200'
                />
                <path
                    d='M14.1612 1.57109C14.2867 1.58127 14.4157 1.63896 14.5039 1.69665V1.11979C14.4157 1.18087 14.2867 1.23177 14.1612 1.24534C14.1748 1.11979 14.229 0.990844 14.2867 0.902618H13.7099C13.771 0.990844 13.8219 1.11979 13.8354 1.24534C13.7099 1.23177 13.5809 1.18087 13.4927 1.11979V1.69665C13.5809 1.63896 13.7099 1.58467 13.8354 1.57109C13.8219 1.69325 13.7676 2.01561 13.7099 2.10384H14.2867C14.229 2.01561 14.1748 1.69325 14.1612 1.57109Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.0017 3.2338C14.1272 3.2338 14.2901 3.41703 14.1714 3.66474C14.5887 3.49168 14.5039 4.17373 14.1714 3.95656C14.1476 4.16695 14.3987 4.34679 14.6498 4.3943C15.0129 4.45877 15.2029 4.15677 15.1724 4.08551C14.8195 4.16695 14.8975 3.56294 15.2742 3.76993C15.2233 3.62742 15.2945 3.4815 15.4812 3.47132C15.6508 3.54598 15.6746 3.70207 15.5762 3.82083C16.0003 3.75297 15.8714 4.34679 15.566 4.15337C15.5151 4.21106 15.5389 4.4418 15.8069 4.5436C16.0309 4.62843 16.2548 4.48931 16.265 4.31964C16.1259 4.29589 16.0478 4.16355 16.1259 4.03122C16.2039 3.89549 16.3736 3.95317 16.4143 4.02443C16.4211 3.81405 16.3532 3.70207 16.4245 3.5324C16.5093 3.59348 16.679 3.74279 16.757 3.80387C16.8419 3.87173 16.7808 3.95996 16.6145 4.16355C16.7095 4.28571 16.5602 4.47234 16.4516 4.42484C16.3974 4.5945 16.3634 4.81167 16.2616 4.81506C16.2718 4.97115 16.2379 5.31048 16.1293 5.5039C16.3702 5.61927 16.1666 6.02647 15.9936 5.95521C15.6882 5.82287 14.7686 5.755 14.0017 5.755C13.2348 5.755 12.3118 5.82287 12.0064 5.95521C11.8368 6.02986 11.6298 5.62266 11.8707 5.5039C11.7587 5.31048 11.7282 4.97115 11.7384 4.81506C11.6366 4.80828 11.6026 4.5945 11.5484 4.42484C11.4398 4.47234 11.2905 4.28571 11.3855 4.16355C11.2158 3.95996 11.1581 3.87173 11.243 3.80387C11.3244 3.74279 11.4907 3.59348 11.5755 3.5324C11.6501 3.70207 11.5823 3.81405 11.5857 4.02443C11.623 3.95317 11.7961 3.89549 11.8707 4.03122C11.9488 4.16355 11.8707 4.29589 11.7316 4.31964C11.7418 4.48931 11.9657 4.62843 12.1897 4.5436C12.4611 4.4418 12.4849 4.21106 12.434 4.15337C12.132 4.34679 11.9997 3.75297 12.4238 3.82083C12.3288 3.70207 12.3526 3.54598 12.5222 3.47132C12.7055 3.4815 12.7801 3.62742 12.7326 3.76993C13.1093 3.56294 13.1839 4.16695 12.831 4.08551C12.8039 4.15677 12.9905 4.46216 13.357 4.3943C13.6047 4.34679 13.8592 4.16695 13.832 3.95656C13.4995 4.17373 13.4147 3.49168 13.832 3.66474C13.7099 3.41703 13.8795 3.2338 14.0017 3.2338Z'
                    fill='#FFF200'
                />
                <path
                    d='M14.0017 3.2338C14.1272 3.2338 14.2901 3.41703 14.1714 3.66474C14.5887 3.49168 14.5039 4.17373 14.1714 3.95656C14.1476 4.16695 14.3987 4.34679 14.6498 4.3943C15.0129 4.45877 15.2029 4.15677 15.1724 4.08551C14.8195 4.16695 14.8975 3.56294 15.2742 3.76993C15.2233 3.62742 15.2945 3.4815 15.4812 3.47132C15.6508 3.54598 15.6746 3.70207 15.5762 3.82083C16.0003 3.75297 15.8714 4.34679 15.566 4.15337C15.5151 4.21106 15.5389 4.4418 15.8069 4.5436C16.0309 4.62843 16.265 4.48931 16.265 4.31964C16.1259 4.29589 16.0478 4.16355 16.1259 4.03122C16.2039 3.89549 16.3736 3.95317 16.4143 4.02443C16.4143 3.81405 16.3532 3.70207 16.4245 3.5324C16.5093 3.59348 16.679 3.74279 16.757 3.80387C16.8419 3.87173 16.7808 3.95996 16.6145 4.16355C16.7095 4.28571 16.5602 4.47234 16.4516 4.42484C16.3974 4.5945 16.3634 4.81167 16.2616 4.81506C16.2616 4.97115 16.2379 5.31048 16.1293 5.5039C16.3702 5.61927 16.1666 6.02647 15.9936 5.95521C15.6882 5.82287 14.7686 5.755 14.0017 5.755C13.2348 5.755 12.3118 5.82287 12.0064 5.95521C11.8368 6.02986 11.6298 5.62266 11.8707 5.5039C11.7587 5.31048 11.7384 4.97115 11.7384 4.81506C11.6366 4.80828 11.6026 4.5945 11.5484 4.42484C11.4398 4.47234 11.2905 4.28571 11.3855 4.16355C11.2158 3.95996 11.1581 3.87173 11.243 3.80387C11.3244 3.74279 11.4907 3.59348 11.5755 3.5324C11.6501 3.70207 11.5857 3.81405 11.5857 4.02443C11.623 3.95317 11.7961 3.89549 11.8707 4.03122C11.9488 4.16355 11.8707 4.29589 11.7316 4.31964C11.7316 4.48931 11.9657 4.62843 12.1897 4.5436C12.4611 4.4418 12.4849 4.21106 12.434 4.15337C12.132 4.34679 11.9997 3.75297 12.4238 3.82083C12.3288 3.70207 12.3526 3.54598 12.5222 3.47132C12.7055 3.4815 12.7801 3.62742 12.7326 3.76993C13.1093 3.56294 13.1839 4.16695 12.831 4.08551C12.8039 4.15677 12.9905 4.46216 13.357 4.3943C13.6047 4.34679 13.8592 4.16695 13.832 3.95656C13.4995 4.17373 13.4147 3.49168 13.832 3.66474C13.7099 3.41703 13.8795 3.2338 14.0017 3.2338Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.0017 2.84018C13.6352 2.84018 13.6352 3.33899 14.0017 3.33899C14.3682 3.33899 14.3716 2.84018 14.0017 2.84018Z'
                    fill='#FFF200'
                />
                <path
                    d='M14.0017 2.84018C13.6352 2.84018 13.6352 3.33899 14.0017 3.33899C14.3682 3.33899 14.3716 2.84018 14.0017 2.84018Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.0017 2.31761C15.1181 2.31761 16.4041 3.01323 16.9267 3.48829C17.0692 3.62742 16.8656 3.92263 16.7299 3.80387C16.2209 3.32881 15.0943 2.69427 14.0017 2.69427C12.9091 2.69427 11.7791 3.32881 11.2701 3.80387C11.1344 3.92603 10.9308 3.63081 11.0767 3.48829C11.5959 3.01323 12.8819 2.321 14.0017 2.31761Z'
                    fill='#FFF200'
                />
                <path
                    d='M14.0017 2.31761C15.1181 2.31761 16.4041 3.01323 16.9267 3.48829C17.0692 3.62742 16.8656 3.92263 16.7299 3.80387C16.2209 3.32881 15.0943 2.69427 14.0017 2.69427C12.9091 2.69427 11.7791 3.32881 11.2701 3.80387C11.1344 3.92603 10.9308 3.63081 11.0767 3.48829C11.5959 3.01323 12.8819 2.321 14.0017 2.31761Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12.6817 4.78792C12.3084 4.85579 12.3797 5.2528 12.753 5.18833C13.1296 5.12046 13.0652 4.72345 12.6817 4.78792Z'
                    fill='#ED1C2E'
                />
                <path
                    d='M12.6817 4.78792C12.3084 4.85579 12.3797 5.2528 12.753 5.18833C13.1296 5.12046 13.0652 4.72345 12.6817 4.78792Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.0017 5.10009C14.229 5.10009 14.4157 5.15099 14.4157 4.91007C14.4157 4.66915 14.2324 4.71665 14.0017 4.71665C13.771 4.71665 13.5843 4.66575 13.5843 4.91007C13.5843 5.15439 13.771 5.10009 14.0017 5.10009Z'
                    fill='#ED1C2E'
                />
                <path
                    d='M14.0017 5.10009C14.229 5.10009 14.4157 5.15099 14.4157 4.91007C14.4157 4.66915 14.2324 4.71665 14.0017 4.71665C13.771 4.71665 13.5843 4.66575 13.5843 4.91007C13.5843 5.15439 13.771 5.10009 14.0017 5.10009Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12.0404 5.08653C11.8436 5.30031 11.735 5.4564 11.6773 5.17476C11.6264 4.89312 11.7927 5.00849 12.0404 5.08653Z'
                    fill='#ED1C2E'
                />
                <path
                    d='M12.0404 5.08653C11.8436 5.30031 11.735 5.4564 11.6773 5.17476C11.6264 4.89312 11.7927 5.00849 12.0404 5.08653Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M15.3149 4.78792C15.6916 4.85579 15.6203 5.2528 15.247 5.18833C14.8704 5.12046 14.9348 4.72345 15.3149 4.78792Z'
                    fill='#ED1C2E'
                />
                <path
                    d='M15.3149 4.78792C15.6916 4.85579 15.6203 5.2528 15.247 5.18833C14.8704 5.12046 14.9348 4.72345 15.3149 4.78792Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M15.9596 5.08653C16.1598 5.30031 16.2684 5.4564 16.3227 5.17476C16.3736 4.89312 16.2073 5.00849 15.9596 5.08653Z'
                    fill='#ED1C2E'
                />
                <path
                    d='M16.2616 4.81845C15.9121 4.66915 14.7245 4.52324 14.0017 4.52324C13.2789 4.52324 12.0913 4.66915 11.7384 4.81845M16.1293 5.50729C15.8273 5.36138 14.7686 5.26976 14.0017 5.26976C13.2314 5.26976 12.1727 5.36138 11.8707 5.50729M15.9596 5.08652C16.1598 5.3003 16.2684 5.45639 16.3227 5.17475C16.3736 4.89311 16.2073 5.00848 15.9596 5.08652Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.0869 3.0811C10.7 3.0811 10.6932 3.65117 11.0801 3.65457C11.4669 3.65457 11.4771 3.08449 11.0869 3.0811Z'
                    fill='white'
                />
                <path
                    d='M11.0869 3.0811C10.7 3.0811 10.6932 3.65117 11.0801 3.65457C11.4669 3.65457 11.4771 3.08449 11.0869 3.0811Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.5959 2.71123C11.209 2.71123 11.2056 3.2813 11.5891 3.28469C11.9759 3.28469 11.9861 2.71462 11.5959 2.71123Z'
                    fill='white'
                />
                <path
                    d='M11.5959 2.71123C11.209 2.71123 11.2056 3.2813 11.5891 3.28469C11.9759 3.28469 11.9861 2.71462 11.5959 2.71123Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12.149 2.43298C11.7655 2.43298 11.7587 3.00645 12.149 3.00645C12.5358 3.01323 12.5426 2.43638 12.149 2.43298Z'
                    fill='white'
                />
                <path
                    d='M12.149 2.43298C11.7655 2.43298 11.7587 3.00645 12.149 3.00645C12.5358 3.01323 12.5426 2.43638 12.149 2.43298Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12.7292 2.19884C12.3424 2.19884 12.339 2.7723 12.7292 2.7757C13.1127 2.7757 13.1228 2.20562 12.7292 2.19884Z'
                    fill='white'
                />
                <path
                    d='M12.7292 2.19884C12.3424 2.19884 12.339 2.7723 12.7292 2.7757C13.1127 2.7757 13.1228 2.20562 12.7292 2.19884Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M13.3196 2.02579C12.9328 2.019 12.9294 2.59586 13.3129 2.59925C13.6997 2.59925 13.7065 2.02579 13.3196 2.02579Z'
                    fill='white'
                />
                <path
                    d='M13.3196 2.02579C12.9328 2.019 12.9294 2.59586 13.3129 2.59925C13.6997 2.59925 13.7065 2.02579 13.3196 2.02579Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.0017 1.87309C13.5266 1.87309 13.5266 2.5789 14.0017 2.5789C14.4768 2.5789 14.4801 1.87309 14.0017 1.87309Z'
                    fill='white'
                />
                <path
                    d='M14.0017 1.87309C13.5266 1.87309 13.5266 2.5789 14.0017 2.5789C14.4768 2.5789 14.4801 1.87309 14.0017 1.87309Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M16.9131 3.0811C17.3 3.0811 17.3034 3.65117 16.9199 3.65457C16.5331 3.65457 16.5263 3.08449 16.9131 3.0811Z'
                    fill='white'
                />
                <path
                    d='M16.9131 3.0811C17.3 3.0811 17.3034 3.65117 16.9199 3.65457C16.5331 3.65457 16.5263 3.08449 16.9131 3.0811Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M16.4041 2.71123C16.791 2.71123 16.7944 3.2813 16.4109 3.28469C16.0241 3.28469 16.0173 2.71462 16.4041 2.71123Z'
                    fill='white'
                />
                <path
                    d='M16.4041 2.71123C16.791 2.71123 16.7944 3.2813 16.4109 3.28469C16.0241 3.28469 16.0173 2.71462 16.4041 2.71123Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M15.851 2.43298C16.2379 2.43298 16.2413 3.00645 15.851 3.00645C15.4642 3.01323 15.4574 2.43638 15.851 2.43298Z'
                    fill='white'
                />
                <path
                    d='M15.851 2.43298C16.2379 2.43298 16.2413 3.00645 15.851 3.00645C15.4642 3.01323 15.4574 2.43638 15.851 2.43298Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M15.2708 2.19884C15.6576 2.19884 15.661 2.7723 15.2776 2.7757C14.8907 2.7757 14.8806 2.20562 15.2708 2.19884Z'
                    fill='white'
                />
                <path
                    d='M15.2708 2.19884C15.6576 2.19884 15.661 2.7723 15.2776 2.7757C14.8907 2.7757 14.8806 2.20562 15.2708 2.19884Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14.6837 2.02579C15.0672 2.019 15.074 2.59586 14.6837 2.59925C14.2969 2.59925 14.2901 2.02579 14.6837 2.02579Z'
                    fill='white'
                />
                <path
                    d='M14.6837 2.02579C15.0672 2.019 15.074 2.59586 14.6837 2.59925C14.2969 2.59925 14.2901 2.02579 14.6837 2.02579Z'
                    stroke='#4E4956'
                    strokeWidth='0.15'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_407'>
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
